import React from 'react';

const AdminForgotPasswordForm = ({ email, errorMessage, successMessage, loading, formSubmitted, handleEmailChange, showEmailField }) => {
  return (
    <div>
      <div className="admin__modal-column">
        {showEmailField && (
          <div className="form-group">
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="Email"
              maxLength="255"
              className={formSubmitted && !email && !successMessage ? 'missing-field' : ''}
            />
            <div className="error-message-container">
              {formSubmitted && !email && !successMessage && (
                <p className="error-message">Email is required</p>
              )}
            </div>
          </div>
        )}
        
        {errorMessage && (
          <div className="error-message-container">
            <p className="error-message">{errorMessage}</p>
          </div>
        )}
        {successMessage && (
          <div className="success-message-container">
            <p className="success-message">{successMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminForgotPasswordForm;